import { Component, OnInit } from '@angular/core';
import { AuthService } from '../core/services/auth.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-glissandco',
  templateUrl: './patinoires-mobiles.component.html',
  styleUrls: ['./patinoires-mobiles.component.css'],
  
})
export class PatinoiresMobilesComponent implements OnInit {

  isShowDetail:boolean = false
  displayName:any
  email:any
  phone:any
  message:any

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit(): void {
  }


  showDetail() {
    this.isShowDetail = true
  }

  
  sendEmail() {
    this.authService.createNewEMail(
      {
        displayName:this.displayName,
        email:this.email,
        phone:this.phone,
        message:this.message
      }
    )
    .then((result) => {
    console.log('SEND MAIL', result)
      
    Swal.fire({
      title: 'Merci !',
      text: 'Votre message a bien été envoyé !',
      icon: 'success',
      confirmButtonText: 'OK'
    })
   
    });
  }

}
